export const AB_TEST_VARIANTS = [ "test", "control" ] as const;

export type AbTestVariant = typeof AB_TEST_VARIANTS[number];

export const isAbTestVariant = (value: unknown): value is AbTestVariant =>
  typeof value === "string" && (AB_TEST_VARIANTS as readonly string[]).includes(value);

export const parseAbTestVariant = (value: unknown): AbTestVariant | undefined =>
  isAbTestVariant(value) ? value : undefined;
